import { STATUS_VARIANTS } from '../constants/common';

export const getTransactionStatusLabel = (status) => {
  switch (status) {
    case STATUS_VARIANTS.completed:
      return 'VALIDÉ';
    case STATUS_VARIANTS.pending:
      return 'EN COURS';
    case STATUS_VARIANTS.rejected:
      return 'ÉCHOUÉ';
    default:
      return '';
  }
};
